import React, { useEffect, useState } from 'react';
import EmployeeAPIs from '../../../../../../../../MasonyFixingsAPIs/EmployeeAPIs/EmployeeAPIs';
import { Form } from 'react-bootstrap';
import { AiFillEdit } from "react-icons/ai";
import { MdCancel, MdEdit } from "react-icons/md";
import { FaSave } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import { useToast } from '../../../../../../../../Contexts/ToastContext';

export default function ViewProjectContractorEmployee({employeeID}){

    const { addToast } = useToast();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [editing, setEditing] = useState(false);
    const [sending, setSending] = useState(false);
    const [employeeData, setEmployeeData] = useState();

    const [phone, setPhone] = useState();
    const [email, setEmail] = useState('');

    const getEmployee = (employeeID) => {

        EmployeeAPIs.GetEmployee(employeeID)
        .then((response) => {
            if(response.status === 200){
                setEmployeeData(response.data);
                setPhone(response.data.phone ?? '');
                setEmail(response.data.email ?? '');
                setLoading(false);
            }
        })
        .catch((err) => {
            console.log(err)
            if(err.response.status === 401){
                if(err.response.data.logout){
                    navigate('/login');
                }
                else{
                    window.alert(err.response.data.message)
                }
            }
        })
    }

    const editEmployee = () => {
        setSending(true)
        const putJSON = {
            phone: phone,
            email: email === '' ? null : email
        }

        EmployeeAPIs.PutEmployee(employeeID, putJSON)
        .then((response) => {
            if(response.status === 200){
                setEditing(false);
                getEmployee(employeeID);
                setSending(false);
                addToast({ message: "Employee details updated successfully!", variant: "success", autoHide: true });
            }
        })
        .catch((err) => {
            console.log(err)
            setSending(false);
            if(err.response.status === 401){
                if(err.response.data.logout){
                    navigate('/login');
                }
                else{
                    window.alert(err.response.data.message)
                }
            }
        })
    }

    const handleCancel = () => {
        setPhone(employeeData.phone ?? '');
        setEditing(false);
    }
    useEffect(() => {
        if(employeeID){
            getEmployee(employeeID);
        }
    }, [employeeID]);

    if(!employeeID) return (<div>No employee selected</div>)

    if(loading){
        return(<div>Loading employee details..</div>)
    }
    else{
        return(
            <div className="project-section">
                <div className="project-section-header">

                     <h5 className="section-title">Phone & Email</h5>
                    <div className="project-header-actions">
                        <button
                            disabled={sending || !editing}
                            onClick={() => editEmployee()}
                            className="save-btn"
                            style={editing ? {display: 'block'} : {display: 'none'}}
                        >
                            {sending ? 'Saving...' : 'Save'}
                        </button>

                        {editing ? (
                            <button
                                disabled={sending}
                                type="button"
                                className="cancel-btn"
                                onClick={handleCancel}
                            >
                                Cancel
                            </button>
                        ) : (
                            <button
                                disabled={sending}
                                type="button"
                                className="edit-btn"
                                onClick={() => setEditing(true)}
                            >
                                <MdEdit /> Edit
                            </button>
                        )}
                    </div>
                    </div>

                    <div className="project-section-body">
                        <div className="project-section-body-item">
                            <span className="label">Phone:</span>
                            {editing? 
                                <Form.Control className='editable-field' size='sm' value={phone} onChange={(e) => setPhone(e.target.value)}/>
                                :
                                employeeData.phone
                                }
                        </div>

                    
                        <div className="project-section-body-item">
                            <span className="label">Email:</span>
                            {editing? 
                                <Form.Control className='editable-field' size='sm' type='email' value={email} onChange={(e) => setEmail(e.target.value)}/>
                                :
                                employeeData.email
                                }
                        </div>

                    </div>





                    {/* {editing ? 
                        <>
                            <button disabled={sending} type="button" onClick={() => handleCancel()}><MdCancel/></button>
                            <button disabled={sending} type={"submit"} onClick={() => editEmployee()}><FaSave/></button>
                        </>
                        :
                        <button type="button" onClick={() => setEditing(true)}><AiFillEdit/></button>
                    } */}
                
                {/* <strong>Phone</strong>
                <div>
                
                    {editing? 
                    <Form.Control size='sm' value={phone} onChange={(e) => setPhone(e.target.value)}/>
                    :
                     phone
                    }
                </div>
                <strong>Email</strong>
                <div>
                
                    {editing? 
                    <Form.Control size='sm' value={email} onChange={(e) => setEmail(e.target.value)}/>
                    :
                     email
                    }
                </div> */}
            </div>
        )
    }

}